import {useCallback} from 'react'

import Icon from '../../../../../common/Icon/Icon'
import ValueToClickAction from '../../../../../common/ValueToClickAction/ValueToClickAction'
import {OrderByField, OrderDirection} from '../../../../../packages/Tests/Tests.types'

import styles from './TestHistoryListHeader.css'

type Props = {
  order: OrderDirection
  orderBy: OrderByField
  onChangeQueryParams: (arg0: Record<string, string | null | undefined>) => unknown
}

function TestHistoryListHeader({orderBy, order, onChangeQueryParams}: Props) {
  const onChangeSorting = useCallback(
    (newOrderBy: string) => {
      let newOrder: OrderDirection = OrderDirection.DESC

      if (newOrderBy === orderBy) {
        if (order === OrderDirection.DESC) {
          newOrder = OrderDirection.ASC
        }
      }

      onChangeQueryParams({
        orderBy: newOrderBy,
        order: newOrder,
      })
    },
    [orderBy, order, onChangeQueryParams],
  )
  const renderColumn = useCallback(
    (
      type: 'status' | 'duration' | 'build' | 'changes' | 'agent' | 'buildStartDate',
      name: string,
      withSorting = false,
    ) => {
      const icon = order === OrderDirection.ASC ? 'chevron-up' : 'chevron-down'
      const sortable = (
        <ValueToClickAction
          value={type}
          onClick={onChangeSorting}
          child={
            <button type="button" className={styles.sortableColumnTitle}>
              {orderBy === type && <Icon name={icon} />}
              {name}
            </button>
          }
        />
      )
      const nonSortable = <span>{name}</span>
      return (
        <div className={styles[`${type}Column`]} key={type}>
          {withSorting ? sortable : nonSortable}
        </div>
      )
    },
    [orderBy, order, onChangeSorting],
  )
  return (
    <div className={styles.tableHeader}>
      {[
        renderColumn(OrderByField.STATUS, 'Status', true),
        renderColumn(OrderByField.DURATION, 'Duration', true),
        renderColumn('build', 'Build'),
        <div className={styles.buildDetailsColumn} key="buildDetails" />,
        renderColumn('changes', 'Changes'),
        renderColumn('agent', 'Agent'),
        renderColumn('buildStartDate', 'Started', true),
        <div className={styles.actionsColumn} key="actions" />,
      ].filter(Boolean)}
    </div>
  )
}

export default TestHistoryListHeader
